/**
 * pi-before-after-split – sync media track + fading content panels
 */
(function () {
  function init(root) {
    if (!root || root.dataset.basInit === '1') return;
    var count = parseInt(root.getAttribute('data-bas-count'), 10) || 0;
    if (count < 1) return;

    root.dataset.basInit = '1';
    var track = root.querySelector('[data-bas-track]');
    var panels = root.querySelectorAll('[data-bas-content-panel]');
    var prevBtn = root.querySelector('[data-bas-prev]');
    var nextBtn = root.querySelector('[data-bas-next]');
    var dots = root.querySelectorAll('[data-bas-dot]');

    var index = 0;
    var autoplayTimer = null;

    var autoplay = root.getAttribute('data-bas-autoplay') === 'true';
    var intervalSec = parseInt(root.getAttribute('data-bas-autoplay-interval') || '6', 10);

    function setIndex(next) {
      if (count < 1) return;
      index = ((next % count) + count) % count;
      if (track) {
        var pct = (index * 100) / count;
        track.style.transform = 'translateX(-' + pct + '%)';
      }
      panels.forEach(function (el, i) {
        var active = i === index;
        el.classList.toggle('is-active', active);
        el.setAttribute('aria-hidden', active ? 'false' : 'true');
        el.tabIndex = -1;
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
    }

    function go(delta) {
      setIndex(index + delta);
      resetAutoplay();
    }

    function resetAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
      if (autoplay && count > 1 && intervalSec >= 3) {
        autoplayTimer = setInterval(function () {
          go(1);
        }, intervalSec * 1000);
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        go(-1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        go(1);
      });
    }
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var i = parseInt(dot.getAttribute('data-bas-dot'), 10);
        if (!isNaN(i)) {
          setIndex(i);
          resetAutoplay();
        }
      });
    });

    var viewport = root.querySelector('[data-bas-media-viewport]');
    if (viewport && count > 1) {
      var startX = 0;
      var dx = 0;
      viewport.addEventListener(
        'touchstart',
        function (e) {
          if (!e.touches || !e.touches[0]) return;
          startX = e.touches[0].clientX;
          dx = 0;
        },
        { passive: true }
      );
      viewport.addEventListener(
        'touchmove',
        function (e) {
          if (!e.touches || !e.touches[0]) return;
          dx = e.touches[0].clientX - startX;
        },
        { passive: true }
      );
      viewport.addEventListener('touchend', function () {
        if (Math.abs(dx) > 50) {
          go(dx < 0 ? 1 : -1);
        }
        dx = 0;
      });
    }

    root.addEventListener('keydown', function (e) {
      if (count < 2) return;
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        go(-1);
      }
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        go(1);
      }
    });

    setIndex(0);
    resetAutoplay();
  }

  document.querySelectorAll('[data-bas-root]').forEach(init);

  document.addEventListener('shopify:section:load', function (ev) {
    var root = ev.target && ev.target.querySelector && ev.target.querySelector('[data-bas-root]');
    if (root) {
      root.dataset.basInit = '0';
      init(root);
    }
  });
})();
